import { VideoModel } from "../schema/video.model";
import { MongoBaseContainer } from "./mongo-base-container.model";

export class VideoContainer extends MongoBaseContainer{
    video: VideoModel
}